import { API_HOST } from "../../config"

export function getBlockHeightTimestamp(height: number): Promise<number> {
  return fetch(`${API_HOST}/extended/v1/block/by_height/${height}`)
    .then(r => (r.ok ? r.json() : Promise.reject(new Error(r.statusText))))
    .then(r => r.burn_block_time * 1000)
}
